import { render, staticRenderFns } from "./tyjrsw.vue?vue&type=template&id=31b4681e&scoped=true&"
import script from "./tyjrsw.vue?vue&type=script&lang=js&"
export * from "./tyjrsw.vue?vue&type=script&lang=js&"
import style0 from "./tyjrsw.vue?vue&type=style&index=0&id=31b4681e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b4681e",
  null
  
)

export default component.exports